// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1VZjK","colMaxWidth":"Table_colMaxWidth__1sHzn"};